import { Link } from "react-router-dom";
import siteConfig from "../../config/site";
import Footer from "../../Components/Footer/Footer";

const Calgary = () => {
  const { services } = siteConfig;

  return (
    <div className="bg-[#0a0a0f] min-h-screen">
      {/* Header */}
      <div className="pt-32 pb-16 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-gold text-sm font-semibold uppercase tracking-widest mb-4">Calgary, Alberta</p>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4">
            Private VIP Entertainment in Calgary, AB
          </h1>
          <div className="w-24 h-0.5 bg-gradient-to-r from-purple-700 to-gold mx-auto mb-6" />
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Premium private entertainment experiences for bachelor parties, private events, 
            and VIP shows throughout Calgary.
          </p>
        </div>
      </div>

      {/* Service Area */}
      <section className="px-6 pb-16">
        <div className="max-w-4xl mx-auto">
          <div className="p-8 rounded-2xl bg-gray-900/40 border border-purple-900/30">
            <h2 className="text-2xl font-bold text-white mb-4">
              Serving All of Calgary
            </h2>
            <p className="text-gray-400 leading-relaxed mb-6">
              Exo Entertainment provides outcall entertainment services throughout Calgary city limits. 
              Whether you're hosting a bachelor party downtown, a private event in the suburbs, or a 
              VIP experience at your hotel — we come to you. Available for bookings 24/7, 365 days a year.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {["Downtown Calgary", "Beltline", "Kensington", "Mission", "Inglewood", "Bridgeland", "South Calgary", "NW Calgary"].map((area) => (
                <div key={area} className="px-3 py-2 rounded-lg bg-gray-800/40 text-gray-300 text-sm text-center">
                  {area}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Services Available */}
      <section className="px-6 pb-16">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8">
            Services Available in Calgary
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {services.map((service, idx) => (
              <div key={idx} className="p-5 rounded-xl bg-gray-900/40 border border-gray-800/30 flex items-start gap-3">
                <span className="text-2xl">{service.icon}</span>
                <div>
                  <h3 className="text-white font-bold text-sm">{service.name}</h3>
                  <p className="text-gold text-sm">{service.price}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Local SEO Content */}
      <section className="px-6 pb-16">
        <div className="max-w-4xl mx-auto space-y-8">
          <div className="p-8 rounded-2xl bg-gray-900/40 border border-gray-800/30">
            <h2 className="text-xl font-bold text-white mb-4">
              Why Choose Exo for Your Calgary Event?
            </h2>
            <p className="text-gray-400 leading-relaxed mb-4">
              Calgary's nightlife and entertainment scene is growing — but private entertainment 
              has always been underserved. Exo Entertainment fills that gap with professional, 
              persona-driven performers who bring a premium experience to your doorstep.
            </p>
            <p className="text-gray-400 leading-relaxed">
              Unlike typical entertainment services, our performers are trained in persona development, 
              audience psychology, and the art of private performance. Every show is curated 
              specifically for your event, whether it's a bachelor party in Kensington, a birthday 
              celebration in Mission, or a private VIP experience at your downtown hotel.
            </p>
          </div>

          <div className="p-8 rounded-2xl bg-gray-900/40 border border-gray-800/30">
            <h2 className="text-xl font-bold text-white mb-4">
              Bachelor Parties in Calgary
            </h2>
            <p className="text-gray-400 leading-relaxed">
              Planning a bachelor party in Calgary? We provide high-energy group entertainment with 
              professional performers who know how to make your celebration unforgettable. Outcall 
              service to your Airbnb, hotel suite, or private venue. Custom packages available for 
              groups of any size. Cash payment, no awkward receipts.
            </p>
          </div>

          <div className="p-8 rounded-2xl bg-gray-900/40 border border-gray-800/30">
            <h2 className="text-xl font-bold text-white mb-4">
              Private VIP Experiences
            </h2>
            <p className="text-gray-400 leading-relaxed">
              For those seeking something more intimate, our Private VIP Dance package offers a 
              one-on-one experience in a curated hotel room setting. Choose your performer, enjoy 
              a complimentary beverage, and experience a premium show in complete privacy. 
              Available throughout Calgary — we handle all the arrangements.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 px-6 bg-gradient-to-b from-[#0a0a0f] via-purple-950/10 to-[#0a0a0f]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            Book Your Calgary Experience
          </h2>
          <p className="text-gray-400 mb-6">
            Available 24/7 throughout Calgary city limits.
          </p>
          <Link
            to="/book"
            className="inline-block px-10 py-4 bg-gold text-black font-bold text-lg rounded-full hover:bg-gold-light transition-all duration-300 shadow-lg shadow-gold/30"
          >
            Book Now
          </Link>
          <p className="text-gray-500 text-sm mt-4">
            Or email us at{" "}
            <a href="mailto:booking@exoentertainment.ca" className="text-gold hover:text-gold-light">
              booking@exoentertainment.ca
            </a>
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Calgary;
